function noValidation(item) {
    return true || item
}

function required(message) {
    return function (val) {
        return !!val || message
    }
}

function greaterThanX(message) {
    return function (val, x) {
        return val > x || message
    }
}

function validateEmail(message) {
    return function (val) {
        const emailFormat = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        if (val) {
            if (val.length > 0) {
                return emailFormat.test(val) || message;
            }
        }
    }
}

function validateDate(message) {
    return function (val) {
        const dateFormat = /([12]\d{3}\/(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01]))/;
        if (val) {
            if (val.length > 0) {
                return dateFormat.test(val) || message;
            }
        }
    }
}

export { required, greaterThanX, noValidation, validateEmail, validateDate }

